export const layersAkief = (state) => state.layers.layersAkief;
export const layersAkief_verkenning = (state) => state.layers_verkenning.layersAkief_verkenning;

export const layersAkief_legacy = (state) => state.layers_legacy.layersAkief_legacy;

export const instruksiesGekry = (state) => state.instruksies.datagekry;
export const instruksieKryDatum = (state) => state.instruksies.datum;

export const instruksiesCards = (state) => state.instruksies.instruksies_cards.initialData;

export const plase = (state) => state.plaseBlokke.plase;

export const map = (state) => state.map.map;

export const google = (state) => state.map.google;

export const layersAkief_custom = (state) => state.layers_custom.layersAkief_custom;
export const layersmetadata_custom = (state) => state.layers_custom.layersmetadata_custom;
export const editing_customlayer = (state) => state.layers_custom.editting;
export const editlayer_resetdata_customlayer = (state) => state.layers_custom.editlayer_resetdata;
export const logs_customlayer = (state) => state.layers_custom.logs;
export const drawingManager_customlayer = (state) => state.layers_custom.drawingManager;
export const style_customlayer = (state) => state.layers_custom.templaaticon;